import { useCallback, useEffect, useRef, useState } from "react";
import { bootstrapCsrfSession } from "../lib/csrfSession";

export function useCsrfSession() {
  const ready = useRef(false);
  const active = useRef(true);
  const [error, setError] = useState(false);
  const ensureReady = useCallback(async () => {
    if (ready.current) return;
    try {
      await bootstrapCsrfSession();
      ready.current = true;
      if (active.current) setError(false);
    } catch (failure) {
      if (active.current) setError(true);
      throw failure;
    }
  }, []);

  useEffect(() => {
    active.current = true;
    ensureReady().catch(() => {}); // The returned error state exposes initialization failures.
    return () => { active.current = false; };
  }, [ensureReady]);

  return { ensureReady, error };
}
